<template>
  <section class="main-block bg-black4 font-Spectral">
    <div class="md:m-auto md:w-11/12 md:max-w-[1216px]">
      <div class="mt-[-50px] text-white md:px-10 md:pt-[50px] lg:mt-[-70px] lg:px-0 lg:pt-[70px]">
        <div class="md:relative">
          <div class="relative h-[530px] sm:h-[680px] md:absolute md:h-auto md:w-1/2">
            <OptimizedImage :class="['h-full w-full object-cover md:h-auto md:w-auto md:object-contain']" :image-url="enStory.mainImage.url" :optimized-image-options="{ width: 1280 }" />
            <div class="absolute left-0 top-0 h-16 w-full bg-gradient-to-b from-black2-transparent-50 to-transparent md:hidden"></div>
          </div>
          <div class="relative px-4 py-12 md:ml-[50%] md:pb-10 md:pl-8 md:pr-0 md:pt-12 lg:pl-[5%] lg:pt-7 xl:min-h-[720px] xl:pl-[4.5rem]">
            <div>
              <div class="flex justify-between">
                <p class="font-Playfair text-xs text-gray1 md:text-lg md:font-normal">Wabunka Story</p>
                <p class="font-Playfair text-xs text-gray1">{{ enStory.date }}</p>
              </div>
              <h1 class="my-4 text-lg leading-[26px] tracking-[0.5px] md:my-2 md:text-[22px] md:leading-[34px]">{{ enStory.title }}</h1>
              <div class="flex items-baseline">
                <p class="mr-3 font-Playfair text-xs text-gray1 md:mr-6">Interviewee</p>
                <!-- eslint-disable-next-line vue/no-v-html -->
                <p class="text-sm md:text-base md:tracking-wide md:text-gray1" v-html="enStory.interviewee"></p>
              </div>
            </div>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div class="desc-area my-8 mb-7 text-lg text-gray1 md:mb-20 md:mt-8 md:text-white" v-html="enStory.introduction"></div>
            <div v-if="enStory.facebookShareUrl || enStory.twitterShareUrl" class="shere-area">
              <p>SHARE</p>
              <div v-if="enStory.facebookShareUrl" class="shere-area__fb">
                <a rel="nofollow noopener noreferrer" target="_blank" :href="enStory.facebookShareUrl"><img class="fb" src="@/assets/icon/facebook/ghost.svg" /></a>
              </div>
              <div v-if="enStory.twitterShareUrl" class="shere-area__twitter">
                <a rel="nofollow noopener noreferrer" target="_blank" :href="enStory.twitterShareUrl"><img class="twitter" src="@/assets/icon/twitter/ghost.svg" /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { EnStoryViewModel } from '@/models/enStory';
import { OptimizedImage } from '@/wabunka-src/common/components';

interface Props {
  enStory: EnStoryViewModel;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
.main-block {
  ::deep {
    .sp-none {
      display: none;

      @apply md:block;
    }

    .pc-none {
      display: block;

      @apply md:hidden;
    }

    .desc-area {
      p {
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0;
        text-align: left;
        margin-bottom: 26px;
        font-weight: 300;
      }
    }

    .shere-area {
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-right: 16px;

      p {
        font-family: Ropa Sans;
        font-size: 10px;
        line-height: 32px;
        letter-spacing: 1px;

        @apply md:text-xs;
      }

      img {
        width: 22px;

        @apply md:w-[30px];
      }

      &__ {
        &fb {
          background: url('@/assets/icon/facebook/gold.svg') no-repeat;
          background-size: contain;
          margin: 0 16px;

          @apply md:mx-6 md:my-0;
        }

        &twitter {
          background: url('@/assets/icon/twitter/gold.svg') no-repeat;
          background-size: contain;
        }

        &fb,
        &twitter {
          img {
            transition: 0.5s;
          }
        }

        &fb:hover,
        &twitter:hover {
          img {
            opacity: 0;
            transition: 0.5s;
          }
        }
      }
    }
  }
}
</style>
